module.exports = __webpack_public_path__ + "static/media/amplio.ee61a510.jpg";